<template>
  <el-drawer :visible.sync="drawer" :with-header="false" size="700px" @close="close">
    <div class="join-inquiry-list-drawer">
      <div>
        <i class="el-icon-close" style="font-size:22px" @click="onClose"></i>
      </div>
      <div class="join-inquier-list-product">
        <!-- 备货货架信息 -->
        <div class="item-box-add">
          <span class="title-font-style">备货货架信息</span>
          <el-table
            border
            ref="tableRef"
            tooltip-effect="dark"
            :data="list"
            :header-cell-style="tableHeader"
            v-loading="loadingTable"
            element-loading-text="拼命加载中请稍后..."
            element-loading-spinner="el-icon-loading"
          >
            <el-table-column label="货架" show-overflow-tooltip>
              <template slot-scope="scope">
                <div class="line-limit-length">{{scope.row.shelvesName || '--'}}</div>
              </template>
            </el-table-column>
            <el-table-column label="入库批次" show-overflow-tooltip>
              <template slot-scope="scope">
                <div class="line-limit-length">{{scope.row.batchNumber || '--'}}</div>
              </template>
            </el-table-column>
            <el-table-column label="货架库存量">
              <template slot-scope="scope">
                <div>{{scope.row.shelvesCount}}</div>
              </template>
            </el-table-column>
            <el-table-column label="历史已锁库">
              <template slot-scope="scope">
                <div>{{scope.row.lockCounts || '--'}}</div>
              </template>
            </el-table-column>
            <el-table-column label="发货数量">
              <template slot-scope="scope">
                <div>{{scope.row.count}}</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 实际库存情况 -->
        <div class="item-box-add">
          <span class="title-font-style">实际库存情况</span>
          <el-table
            border
            ref="tableRef"
            tooltip-effect="dark"
            :data="actualList"
            :header-cell-style="tableHeader"
            v-loading="loadingTable"
            element-loading-text="拼命加载中请稍后..."
            element-loading-spinner="el-icon-loading"
          >
            <el-table-column label="货架" show-overflow-tooltip>
              <template slot-scope="scope">
                <div class="line-limit-length">{{scope.row.shelvesName}}</div>
              </template>
            </el-table-column>
            <el-table-column label="入库批次" show-overflow-tooltip>
              <template slot-scope="scope">
                <div class="line-limit-length">{{scope.row.batchNumber || '--'}}</div>
              </template>
            </el-table-column>
            <el-table-column label="实际库存量">
              <template slot-scope="scope">
                <div>
                  <el-input-number
                    :disabled="disabled"
                    style="width:100px;"
                    v-model="scope.row.shelvesCounts"
                    :min="0"
                    controls-position="right"
                    :max="scope.row.maxs"
                  ></el-input-number>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="历史已锁库">
              <template slot-scope="scope">{{scope.row.lockCounts || '--'}}</template>
            </el-table-column>
            <el-table-column label="实际发货数量">
              <template slot-scope="scope">
                <div>
                  <el-input-number
                    :disabled="disabled"
                    style="width:100px;"
                    v-model="scope.row.nowCount"
                    :min="0"
                    controls-position="right"
                    :max="scope.row.maxCount"
                  ></el-input-number>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 仓库调用区 -->
        <div class="item-box-add">
          <span class="title-font-style">仓库调用区</span>
          <draggable
            v-if="isLack === true"
            v-model="callAreaList"
            v-bind="dragOptions"
            @start="isDragging=true"
            @end="isDragging=false"
          >
            <el-table
             max-height="200"
              border
              ref="tableRef"
              tooltip-effect="dark"
              :data="callAreaList"
              :header-cell-style="tableHeader"
              v-loading="loadingTable"
              element-loading-text="拼命加载中请稍后..."
              element-loading-spinner="el-icon-loading"
              style="width: 100%"
            >
              <template slot="empty">
                <div style="height:100px;line-height:21px;padding-top:25px;">
                  <span
                    v-show="callAreaList.length === 0 && useableList.length !== 0"
                    style="line-height:65px;"
                  >允许调用本仓其他货架可备货库存完后才能本次备货</span>
                  <span v-show="callAreaList.length === 0 && useableList.length === 0">
                    <span style="line-height:30px;">本仓库无可用备货库存</span>
                    <div style="line-height:30px;">缺失产品请通过提交报缺方案交由采购配货</div>
                  </span>
                </div>
              </template>
              <el-table-column
                v-for="(item) in col"
                :key="item.label"
                :prop="item.prop"
                :label="item.label"
              >
                <template
                  slot-scope="scope"
                  :move="onMove"
                  @click=" element.fixed=! element.fixed"
                  aria-hidden="true"
                >
                  <div
                    v-if="item.prop==='shelvesName'"
                    class="line-limit-length"
                    show-overflow-tooltip
                  >{{scope.row.shelvesName}}</div>
                  <div
                    v-if="item.prop==='batchNumber'"
                    class="line-limit-length"
                    show-overflow-tooltip
                  >{{scope.row.batchNumber}}</div>
                  <div v-if="item.prop==='count'">{{scope.row.count}}</div>
                  <div v-if="item.prop==='lockCount'">{{scope.row.lockCount}}</div>
                  <div v-if="item.prop==='stockCount'">
                    <el-input-number
                      :disabled="disabled"
                      controls-position="right"
                      style="width:100px;"
                      v-model="scope.row.stockCount"
                      :min="0"
                      :max="scope.row.stockCountMax"
                      @change="getErr"
                    ></el-input-number>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </draggable>
          <el-table
           max-height="200"
            v-if="isLack === false"
            border
            ref="tableRef"
            tooltip-effect="dark"
            :data="callAreaList"
            :header-cell-style="tableHeader"
            v-loading="loadingTable"
            element-loading-text="拼命加载中请稍后..."
            element-loading-spinner="el-icon-loading"
            style="width: 100%"
          >
            <el-table-column
              v-for="(item) in col"
              :key="item.label"
              :prop="item.prop"
              :label="item.label"
            >
              <template
                slot-scope="scope"
                :move="onMove"
                @click=" element.fixed=! element.fixed"
                aria-hidden="true"
              >
                <div
                  v-if="item.prop==='shelvesName'"
                  class="line-limit-length"
                  show-overflow-tooltip
                >{{scope.row.shelvesName}}</div>
                <div
                  v-if="item.prop==='batchNumber'"
                  class="line-limit-length"
                  show-overflow-tooltip
                >{{scope.row.batchNumber}}</div>
                <div v-if="item.prop==='count'">{{scope.row.count}}</div>
                <div v-if="item.prop==='lockCount'">{{scope.row.lockCount}}</div>
                <div v-if="item.prop==='stockCount'">
                  <el-input-number
                    :disabled="disabled"
                    controls-position="right"
                    style="width:100px;"
                    v-model="scope.row.stockCount"
                    :min="0"
                    :max="scope.row.stockCountMax"
                    @change="getErr"
                  ></el-input-number>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="item-box-remarks">
          <span>备注：</span>
          <el-input
            :disabled="disabled"
            v-model="marks"
            type="textarea"
            placeholder="请录入报缺备注！"
            rows="5"
          ></el-input>
        </div>
        <div class="redtip" style="font-size:12px;color:#D35E5E">*说明：备货数量不足时将提交采购重新安排配货</div>
        <!-- 仓库可用库存 -->
        <div class="item-box-add" v-show="showList">
          <span class="title-font-style">仓库可用库存</span>
          <div style="margin-bottom:15px">将欲调用产品拖入仓库调用区完成报缺产品备货</div>
          <draggable
            :disabled="useableList.length===0?true:false"
            v-if="isLack === true"
            v-model="useableList"
            v-bind="dragOptions"
            @start="isDragging=true"
            @end="isDragging=false"
          >
            <el-table
              max-height="200"
              border
              ref="tableRef"
              tooltip-effect="dark"
              :data="useableList"
              :header-cell-style="tableHeader"
              row-key="sspId"
              v-loading="loadingTable"
              element-loading-text="拼命加载中请稍后..."
              element-loading-spinner="el-icon-loading"
              style="width: 100%"
            >
              <el-table-column
                v-for="(item) in col1"
                :key="item.label"
                :prop="item.prop"
                :label="item.label"
                width="124px"
              >
                <template
                  slot-scope="scope"
                  :move="onMove"
                  @click=" element.fixed=! element.fixed"
                  aria-hidden="true"
                >
                  <div
                    v-if="item.prop==='shelvesName'"
                    class="line-limit-length"
                    show-overflow-tooltip
                  >{{scope.row.shelvesName}}</div>
                  <div
                    v-if="item.prop==='batchNumber'"
                    class="line-limit-length"
                    show-overflow-tooltip
                  >{{scope.row.batchNumber}}</div>
                  <div v-if="item.prop==='count'">{{scope.row.count}}</div>
                  <div v-if="item.prop==='lockCount'">{{scope.row.lockCount}}</div>
                  <div v-if="item.prop==='stockCount'">{{scope.row.stockCount}}</div>
                </template>
              </el-table-column>
            </el-table>
          </draggable>
          <el-table
            max-height="200"
            v-if="isLack === false"
            border
            ref="tableRef"
            tooltip-effect="dark"
            :data="useableList"
            :header-cell-style="tableHeader"
            row-key="sspId"
            v-loading="loadingTable"
            element-loading-text="拼命加载中请稍后..."
            element-loading-spinner="el-icon-loading"
            style="width: 100%"
          >
            <el-table-column
              v-for="(item) in col1"
              :key="item.label"
              :prop="item.prop"
              :label="item.label"
              width="124px"
            >
              <template
                slot-scope="scope"
                :move="onMove"
                @click=" element.fixed=! element.fixed"
                aria-hidden="true"
              >
                <div
                  v-if="item.prop==='shelvesName'"
                  class="line-limit-length"
                  show-overflow-tooltip
                >{{scope.row.shelvesName}}</div>
                <div
                  v-if="item.prop==='batchNumber'"
                  class="line-limit-length"
                  show-overflow-tooltip
                >{{scope.row.batchNumber}}</div>
                <div v-if="item.prop==='count'">{{scope.row.count}}</div>
                <div v-if="item.prop==='lockCount'">{{scope.row.lockCount}}</div>
                <div v-if="item.prop==='stockCount'">{{scope.row.stockCount}}</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <el-row style="margin-top:20px;">
        <el-col :span="24" style="text-align:center;" v-if="isLack === true">
          <el-button type="primary" @click="onSubmit">提交报缺方案</el-button>
          <el-button @click="cancle">取 消</el-button>
        </el-col>
      </el-row>
    </div>
    <!-- 提交报缺提示框-->
    <el-dialog
      :append-to-body="true"
      :visible.sync="disableDialog"
      class="dialog-address"
      width="437px"
      title="备货确认"
    >
      <div class="dialog-tip" style="padding-left:30px">备货产品数量不足，缺失数量将由采购重新配货</div>
      <span slot="footer" class="dialog-center">
        <el-button @click="confirm" type="primary">提交</el-button>
        <el-button @click="disableDialog=false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :append-to-body="true"
      :visible.sync="disableDialog2"
      class="dialog-address"
      width="437px"
      title="备货确认"
    >
      <div class="dialog-tip" style="padding-left:30px">确认提交当前报缺方案？</div>
      <span slot="footer" class="dialog-center">
        <el-button @click="confirm2" type="primary">提交</el-button>
        <el-button @click="disableDialog2=false">取消</el-button>
      </span>
    </el-dialog>
  </el-drawer>
</template>
<script>
import { queryShelvesProduct, addDeliverLack } from '@/api/storage/storage'
import draggable from 'vuedraggable'

export default {
  data() {
    return {
      showList: false,
      isLack: false,
      disabled: false,
      disableDialog: false,
      disableDialog2: false,
      drawer: false,
      loadingTable: false,
      params: {},
      list: [], // 备货货架信息
      actualList: [], // 实际库存
      callAreaList: [], // 调用区
      useableList: [], // 仓库可用库存
      stockNumber: 0, // 货架库存量
      LockNumber: 0, // 本次锁库数量
      editable: true,
      isDragging: false,
      delayedDragging: false,
      marks: '', // 备注
      col: [
        {
          label: '货架',
          prop: 'shelvesName'
        },
        {
          label: '入库批次',
          prop: 'batchNumber'
        },
        {
          label: '货架库存量',
          prop: 'count'
        },
        {
          label: '历史已锁库',
          prop: 'lockCount'
        },
        {
          label: '调用数量',
          prop: 'stockCount'
        }
      ],
      col1: [
        {
          label: '货架',
          prop: 'shelvesName'
        },
        {
          label: '入库批次',
          prop: 'batchNumber'
        },
        {
          label: '货架库存量',
          prop: 'count'
        },
        {
          label: '历史已锁库',
          prop: 'lockCount'
        },
        {
          label: '可发货数量',
          prop: 'stockCount'
        }
      ]
    }
  },
  components: {
    draggable
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: 'description',
        disabled: !this.editable,
        ghostClass: 'ghost'
      }
    }
  },
  watch: {
    callAreaList: {
      handler(newVal) {
        // console.log('wogaibianle ')
      },
      deep: true
    },
    isDragging(newValue) {
      // console.log(newValue)
      if (newValue === false) {
        this.callAreaList[0].stockCount = 0
      }
      if (newValue) {
        this.delayedDragging = true
        return
      }
      this.$nextTick(() => {
        this.delayedDragging = false
      })
    }
  },
  methods: {
    // 报缺侧边栏初始化
    onInitialize(row) {
      this.isLack = row.isLack
      if (this.isLack === true) {
        this.disabled = false
      } else {
        this.disabled = true
      }
      this.drawer = true
      const obj = JSON.parse(JSON.stringify(row))
      this.list = [obj]
      this.actualList = [obj]
      this.actualList.forEach(ele => {
        ele.maxs = ele.shelvesCount
        if (ele.shelvesCounts <= ele.lockCounts) {
          ele.maxCount = 0
        } else {
          ele.maxCount = this.list[0].count || ele.shelvesCounts - ele.lockCounts
        }
        this.useableList.forEach(ele => {
          ele.stockCountMax = ele.stockCount
          ele.stock = 0
        })
      })
      this.queryShelvesProduct()
    },
    // 拖拽
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element
      const draggedElement = draggedContext.element
      return (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
    },
    // 仓库可用库存
    queryShelvesProduct() {
      const sbId = this.list[0].sbId
      const proId = this.list[0].proId
      const ssId = this.list[0].ssId
      queryShelvesProduct(sbId, ssId, proId)
        .then(res => {
          if (res.data.code === 200) {
            this.useableList = res.data.obj // 可用库存
            if (this.useableList.length === 0) {
              this.showList = false
            } else {
              this.showList = true
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 导入Excle
    importTable() {},
    // 查看详情
    onDetails() {
      this.$refs.joinInquirySheetRefs.onInitial(this.proAllContent)
    },
    // // 判断实际库存量 不能大于 货架库存量，如果大于的情况弹出提示框
    // getNumber (val) {
    //   console.log('===>')
    //   console.log(val)
    //   if (val > this.list[0].shelvesCount) {
    //     this.$message.error('请移至实时库存货仓库盘点进行报盈')
    //   }
    // },
    // 判断调用数量 不能大于备货数量-本次锁库数量
    getErr() {
      let num = 0
      this.callAreaList.forEach(ele => {
        num += ele.stockCount
      })
      if (num > this.list[0].count - this.actualList[0].nowCount) {
        this.$message.error('调用数量必须 <= 发货数量 + 实际发货数量')
      }
    },
    addDeliverLack() {
      const storageInventoryLacksVoList = []
      this.callAreaList.map(item => {
        storageInventoryLacksVoList.push({
          sspId: item.sspId,
          stockCount: item.stockCount
        })
      })
      const backParams = {
        mark: this.marks, // 备注
        socId: this.list[0].socId, // 仓库方案id
        nowCount: this.actualList[0].nowCount, // 实际发货数量
        shelvesCounts: this.actualList[0].shelvesCounts, // 实际库存数量
        storageInventoryLacksVoList: storageInventoryLacksVoList
      }
      addDeliverLack(backParams)
        .then(res => {
          if (res.data.code === 200) {
            this.$message.success('提交成功!')
            this.addCustormDialog = false
            this.$emit('getList')
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 提交报缺方案
    onSubmit() {
      const storageInventoryLacksVoList = []
      if (this.callAreaList.length !== 0 && this.callAreaList !== null) {
        this.callAreaList.map(item => {
          storageInventoryLacksVoList.push({
            sspId: item.sspId,
            stockCount: item.stockCount
          })
        })
        // 调用数量 !== 发货数量 - 实际发货数量
        if (this.callAreaList[0].stockCount < this.list[0].count - this.actualList[0].nowCount) {
          this.disableDialog = true
        } else if (
          this.callAreaList[0].stockCount ===
          this.list[0].count - this.actualList[0].nowCount
        ) {
          this.disableDialog2 = true
        } else {
          this.$message.error('调用数量必须 <= 发货数量 + 实际发货数量')
        }
      } else {
        const number = this.actualList[0].nowCount
        if (this.list[0].count !== number) {
          this.disableDialog = true
        } else {
          this.disableDialog2 = true
        }
      }
    },
    // 提交报缺方案
    confirm() {
      this.addDeliverLack()
      this.disableDialog = false
      this.drawer = false
    },
    confirm2() {
      this.addDeliverLack()
      this.disableDialog2 = false
      this.drawer = false
    },
    // 取消
    cancle() {
      this.drawer = false
      this.list = []
      this.actualList = []
      this.callAreaList = []
    },
    // 关闭
    onClose() {
      this.drawer = false
      this.list = []
      this.actualList = []
      this.callAreaList = []
    },
    // 关闭事件
    close() {
      this.drawer = false
      this.list = []
      this.actualList = [] // 实际库存
      this.callAreaList = [] // 调用区
    }
  }
}
</script>
<style  lang="scss" scoped>
h5,
h4 {
  text-align: center !important;
}
h5 {
  margin: 0px !important;
  font-size: 14px;
}
.join-inquiry-list-drawer {
  padding: 20px;
  color: #83878a;
  font-size: 14px !important;
  .join-inquier-list-crumbs {
    padding-left: 20px;
    font-size: 14px;
    span:first-child {
      color: #4e555b;
      padding-right: 10px;
    }
  }
  .join-inquier-list-product {
    padding: 30px 0 0 30px;
    .item-box-add {
      margin: 0 0 30px 0;
      .title-font-style {
        margin-bottom: 20px;
        font-weight: bold;
        font-size: 16px;
        color: #4e555b;
      }
    }
    .item-box-remarks {
      width: 100%;
      display: flex;
      span {
        width: 60px;
      }
    }
    .redtip {
      color: #d35e5e;
      margin: 11px 20px;
    }
  }
  .join-inquiry-list-drawer-parameter {
    font-size: 14px;
    margin-top: 20px;
  }
  .join-inquier-list-like-product {
    display: flex;
    justify-content: center;
    align-items: center;
    .el-col-3 {
      div {
        border: 1px solid #e3ecff;
      }
    }
  }
  .dialog-footer {
    width: 180px;
    margin: 30px auto;
    float: right;
  }
}
</style>
